import InfoTooltip from "@/components/InfoTooltip";
import Typography from "@/components/Typography";

import { SummaryCardProps } from "./types";

const SummaryCard = ({
  value,
  date,
  title,
  money,
  tooltip = false,
  constructionAppreciation = 0,
  ipcaAppreciation = 0,
  initialInvestment = 0,
}: SummaryCardProps) => {
  return (
    <div className="flex size-full flex-col gap-6 rounded-3xl bg-white px-6 py-8">
      <div className="flex w-full justify-between">
        <Typography variant="overline" color="grey600" className="uppercase">
          {title}
        </Typography>
        {tooltip && (
          <InfoTooltip
            constructionAppreciation={constructionAppreciation}
            ipcaAppreciation={ipcaAppreciation}
            initialInvestment={initialInvestment}
          />
        )}
      </div>
      <div className="scrollbar-on-hover w-full overflow-x-auto overflow-y-hidden">
        {money && (
          <span className="whitespace-nowrap text-3xl font-bold text-grey950 sm:text-2xl md:text-2xl">
            R$
          </span>
        )}
        <Typography variant="h4" color="grey950" className="whitespace-nowrap">
          {value}
        </Typography>
      </div>

      {date && (
        <Typography variant="overline" color="grey600" className="uppercase">
          {date}
        </Typography>
      )}
    </div>
  );
};

export default SummaryCard;
